import { BaseService } from '../../../http/BaseHttpService';
import {
    GetChatMessagesRequest,
    IChatMessagesService,
    SendChatMessageRequest,
    SendChatMessageResponse,
} from '../../../chat/interfaces/IChatMessagesService';
import { AssistantMessageResponseDto } from '../dtos/responses/AssistantChatMessageDto';
import { buildAssistantsUrl } from '../../../../features/utils/buildAssistantsUrl';

import { ChatProviderType } from '../../../../domain/chat/models/ChatProviderType';
import { AuthorRoles, ChatMessage, ChatMessageType } from '../../../../domain/messages/models/ChatMessage';

const mapAuthorRoleToFrontendRole = (authorRole: number): AuthorRoles => {
    switch (authorRole) {
        case 0:
            return AuthorRoles.User;
        case 1:
            return AuthorRoles.Bot;
        default:
            return AuthorRoles.User;
    }
};

export class AssistantsChatMessagesService extends BaseService implements IChatMessagesService {
    public readonly providerType = ChatProviderType.Assistants;
    private readonly subscriptionKey = process.env.REACT_APP_NEXUS_APIM_SUBSCRIPTION_KEY ?? '';
    private readonly subKeyHeader = process.env.REACT_APP_NEXUS_APIM_KEY_HEADER_NAME ?? '';

    constructor(private readonly baseUrl: string) {
        super();
    }

        public async getChatMessagesAsync(request: GetChatMessagesRequest, accessToken: string): Promise<ChatMessage[]> {
        const response = await this.getResponseAsync<AssistantMessageResponseDto[]>(
            {
                url: buildAssistantsUrl(this.baseUrl, `chatSession/getChatMessages/${request.chatId}`),
                method: 'GET',
                headers: {
                    [this.subKeyHeader]: this.subscriptionKey,
                },
            },
            accessToken,
        );

        return response.map((message) => ({
            id: message.id,
            chatId: message.chatId,
            type: message.type ?? ChatMessageType.Message,
            timestamp: message.timestamp,
            userName: message.userName,
            content: message.content,
            authorRole: mapAuthorRoleToFrontendRole(message.authorRole),
        }));
    }


    // TODO: Remove this before going live.
    public sendMessageAsync(
        _request: SendChatMessageRequest,
        _accessToken: string,
        _signal?: AbortSignal,
    ): Promise<SendChatMessageResponse> {
        throw new Error('Assistants API is read-only. Sending messages is not supported.');
    }
}
